import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import useRouter from '@/composables/useRouter'
import { Icons } from '@/icons/icons'
import { ContextMenuItem } from '@/components/Navigation/AppBarToolbarItems/contextMenus/types'
import { URLS } from '@/router/routes/urlRoutes'
import usePermissions from '@/composables/usePermissions'
import { MaintenanceEntityId } from '@/general/entityIds'
import useUser from '@/composables/useUser'
import { isTrue } from '@/helpers/boolean'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigPanelContextMenuComponent',
  props: {
  showItem: {
    type: Boolean,
    required: false,
    default: true
  },
  configurationUrl: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;



// ROUTER
const { goToRoute } = useRouter()
const { checkEntityPermissionsGetter } = usePermissions()

// TRANSLATIONS
const { t } = useI18n()
const text = {
  activity: t('navigation.activity_log.activity'),
  configurationPanel: t('navigation.activity_log.configuration_panel')
}

const { isFactureUser, isLexonUser } = useUser()

// DATA
const iconConfig = ref(Icons.CONFIGURATION)

const items = computed((): ContextMenuItem[] => {
  const { canView } = checkEntityPermissionsGetter(MaintenanceEntityId.MAINTENANCE)

  return [
    {
      icon: Icons.SETTINGS,
      name: text.configurationPanel,
      url: props.configurationUrl,
      show: isTrue(Boolean(canView) || isFactureUser.value)
    },
    ...(!isLexonUser.value
      ? []
      : [
          {
            icon: Icons.TRACK_RIGHT,
            name: text.activity,
            url: `${URLS.AUDITS}`,
            show: props.showItem
          }
        ])
  ]
})

// METHODS
function redirect(item: ContextMenuItem) {
  goToRoute({
    name: item.url
  })
}

return { __sfc: true,props, goToRoute, checkEntityPermissionsGetter, t, text, isFactureUser, isLexonUser, iconConfig, items, redirect }
}

})